import React from "react";
import { BsExclamationDiamondFill } from "react-icons/bs";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import { renderStartDate, renderEndDate } from "../../resume";
import ResumeUnderlineIconSVG from "assets/svg/resume-underline-icon";
import ResumeLineDividerIconSVG from "assets/svg/resume-line-divider-icon";
import _ from "lodash";
import { formatDate } from "utils/utils";
import { useTranslation } from "react-i18next";
import { CoverPlaceholderMilestone } from "constants/images"; 


const MilestoneTG = ({milestones,primaryColor,show_image_milestone,tertiaryColor,items,active,
  profile,
  fullPreview = false,
  milestone_position=[]
})=>{
    const { t } = useTranslation();
    return (
        <>
            {items.some(element => element.type === 'featured') &&
            !_.isEmpty(items) && (
              <>
                <div className="w-full flex flex-row space-x-6.5">
                  <div className="w-14">
                    <p className="text-6xs font-medium text-resumeTempFourTextPrimary tracking-resumeFour">
                      Featured Milestones
                    </p>
                  </div>
                  <div style={{ width: "calc(100% - 81px)" }}>
                    {items.length > 0 && <div className="w-full grid gap-y-3">
                      {items.map((mf, i) => (
                        mf?.type === 'featured' &&
                        <div
                          className="w-full flex flex-row items-center space-x-2.6"
                          key={`featured-${i}`}>
                          {/* style={{ width: "calc(100% - 111px)" }} */}
                          <div className="w-full">
                            {/* title and date */}
                            <div className="w-full">
                              <div className="w-full flex flex-row items-center justify-between">
                                {/* title */}
                                <div className="flex flex-row items-center space-x-1">
                                  <p className="text-xs text-resumeTempFourTextPrimary font-medium tracking-tight">
                                    {mf?.title}
                                  </p>
                                  <div
                                    className="text-1xs font-bold "
                                    style={{ color: tertiaryColor + "E6" }}>
                                    <span
                                      className="template-four-padding-skills rounded text-opacity-90"
                                      style={{
                                        backgroundColor:
                                          tertiaryColor + "1F", // opcity 12%
                                      }}>
                                      {mf?.category?.name}
                                    </span>
                                  </div>
                                </div>
                                {/* date */}
                                <div>
                                  <p className="text-1xs text-resumeTempFourTextPrimary leading-3.4 flex flex-row items-center space-x-1">
                                    <HiOutlineCalendarDays className="w-2 h-2 text-resumeTempFourIconColor" />
                                    <span className="mt-px">
                                    {formatDate(mf,profile?.dateFormat,t)} 
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* sub title and episodes */}
                            <div className="w-full mt-0.5 leading-none">
                              <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                  {mf?.positions && mf?.positions
                                    .filter(item =>
                                      !milestone_position.some(hide =>
                                        hide?.[mf?.id]?.includes(item.position_id)
                                      )
                                    )
                                    .map((p) => {
                                      const _pos = [p.position.name?.trim()];
                                      if (p.description)
                                        _pos.push((p.description).trim());
                                      return _pos.join(" - ");
                                    })
                                    .join(", ")
                                    .trim()}
                                </span>
                                {mf.platform && (
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">{` (${mf.platform})`}</span>
                                  )}
                                {mf.date_note && (
                                  <>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium px-1">
                                      &#8226;
                                    </span>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                      {mf.date_note}
                                    </span>
                                  </>
                                )}
                              {/* {mf?.positions && mf?.positions.slice(0,2).map((p, i) => (
                                <div
                                  key={`featured-position-${i}`}
                                  className="w-full  flex flex-row space-x-1"
                                  style={{ color: primaryColor }}>
                                  <>
                                    <p className="text-7xs leading-3.5 font-medium">
                                      <span>{p.position.name}</span>
                                      {p.position.description && (
                                        <>
                                          <span> - </span>
                                          <span>
                                            {p.position.description}
                                          </span>
                                        </>
                                      )}
                                      {mf?.platform && (
                                        <span>{` (${mf?.platform})`}</span>
                                      )}
                                    </p>
                                    {mf?.date_note && (
                                      <>
                                        <span className="text-7xs leading-3.5">
                                          &#8226;
                                        </span>
                                        <p className="text-7xs leading-3.5 font-medium">
                                          {mf?.date_note}
                                        </p>
                                      </>
                                    )}
                                  </>
                                </div>
                              ))} */}
                            </div>
                            {/* description */}
                            <div className="w-full mt-2">
                              <div
                                className="text-7xs text-resumeTempFourTextPrimary tracking-resume leading-3.2 line-clamp-3"
                                dangerouslySetInnerHTML={{
                                  __html: mf?.description === 'null' || !mf?.description ? "" :  mf?.description,
                                }}
                              />
                            </div>
                          </div>
                          {/* image */}
                          {show_image_milestone && 
                          <>
                            {
                              mf?.thumbnail ? (
                                <div className="h-23 w-23 bg-default rounded relative overflow-hidden">
                                  <img
                                    alt="milestones"
                                    src={mf?.thumbnail.url}
                                    className="w-full h-full object-contain object-center"
                                  />
                                </div> 
                              )
                              :
                              <div className="h-23 w-23 bg-default rounded flex items-center justify-center relative overflow-hidden">
                                  <img
                                    alt="milestones"
                                    src={CoverPlaceholderMilestone}
                                    className="w-1/2 object-contain object-center"
                                  />
                                </div>
                            }
                          </>
                        }
                        </div>
                      ))}
                    </div>}
                  </div>
                </div>
                {/* Divider */}
                <div className="w-full py-4">
                  <ResumeLineDividerIconSVG full="true" />
                </div>
              </>
            )}
          {/* Current Milestones */}
          {items.some(element => element.type === 'current') &&
            !_.isEmpty(items) && (
              <>
                <div className="w-full flex flex-row space-x-6.5">
                  <div className="w-14">
                    <p className="text-6xs font-medium text-resumeTempFourTextPrimary tracking-resumeFour">
                      Current Milestones
                    </p>
                  </div>
                  <div style={{ width: "calc(100% - 81px)" }}>
                  {items.length && <div className="w-full grid gap-y-3">
                      {items.map((mc, i) => (
                        mc.type === 'current' && 
                        <div
                          className="w-full flex flex-row items-center space-x-2.6"
                          key={`current-${i}`}>
                          <div className="w-full">
                            {/* title and date */}
                            <div className="w-full">
                              <div className="w-full flex flex-row items-center justify-between">
                                {/* title */}
                                <div className="flex flex-row items-center space-x-1">
                                  <p className="text-xs text-resumeTempFourTextPrimary font-medium tracking-tight">
                                    {mc?.title}
                                  </p>
                                  <div
                                    className="text-1xs font-bold"
                                    style={{ color: tertiaryColor + "E6" }}>
                                    <span
                                      className="template-four-padding-skills rounded text-opacity-90"
                                      style={{
                                        backgroundColor:
                                          tertiaryColor + "1F", // opcity 12%
                                      }}>
                                      {mc?.category?.name}
                                    </span>
                                  </div>
                                </div>
                                {/* date */}
                                <div>
                                  <p className="text-1xs text-resumeTempFourTextPrimary leading-3.4 flex flex-row items-center space-x-1">
                                    <HiOutlineCalendarDays className="w-2 h-2 text-resumeTempFourIconColor" />
                                    <span className="mt-px">
                                      {formatDate(mc,profile?.dateFormat,t)} 
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* sub title and episodes */}
                            <div className="w-full mt-0.5 leading-none">
                              <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                  {mc?.positions && mc?.positions
                                    .filter(item =>
                                        !milestone_position.some(hide =>
                                          hide?.[mc?.id]?.includes(item.position_id)
                                        )
                                      ).map((p) => {
                                      const _pos = [p.position.name?.trim()];
                                      if (p.description)
                                        _pos.push((p.description).trim());
                                      return _pos.join(" - ");
                                    })
                                    .join(", ")
                                    .trim()}
                                </span>
                                {mc.platform && (
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">{` (${mc.platform})`}</span>
                                  )}
                                {mc.date_note && (
                                  <>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium px-1">
                                      &#8226;
                                    </span>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                      {mc.date_note}
                                    </span>
                                  </>
                                )}
                            </div>
                            {/* description */}
                            <div className="w-full mt-2">
                              <div
                                className="text-7xs text-resumeTempFourTextPrimary tracking-resume leading-3.2 line-clamp-3"
                                dangerouslySetInnerHTML={{
                                  __html: mc?.description === 'null' || !mc?.description ? "" :  mc?.description,
                                }}
                              />
                            </div>
                          </div>
                          {/* image */}
                          {show_image_milestone && 
                          <>
                            {
                              mc?.thumbnail ? (
                                <div className="h-23 w-23 bg-default rounded relative overflow-hidden">
                                  <img
                                    alt="milestones"
                                    src={mc.thumbnail.url}
                                    className="w-full h-full object-contain object-center"
                                  />
                                </div>
                              )
                                :
                                <div className="h-23 w-23 bg-default rounded flex items-center justify-center relative overflow-hidden">
                                  <img
                                    alt="milestones"
                                    src={CoverPlaceholderMilestone}
                                    className="w-1/2 object-contain object-center"
                                  />
                                </div>
                            }
                          </>
                          }
                        </div>
                      ))}
                    </div>}
                  </div>
                </div>
                {/* Divider */}
                <div className="w-full py-4">
                  <ResumeLineDividerIconSVG full="true" />
                </div>
              </>
            )}
          {/* Past Milestones */}
          {items.some(element => element.type === 'past') &&
            !_.isEmpty(items) && (
              <>
                <div className="w-full flex flex-row space-x-6.5">
                  <div className="w-14">
                    <p className="text-6xs font-medium text-resumeTempFourTextPrimary tracking-resumeFour">
                      Past Milestones
                    </p>
                  </div>
                  <div style={{ width: "calc(100% - 81px)" }}>
                   { items.length &&  <div className="w-full grid gap-y-3">
                      {items.map((mp, i) => (
                        mp.type === 'past' &&
                        <div
                          className="w-full flex flex-row items-center space-x-2.6"
                          key={`past-${i}`}>
                          <div className="w-full">
                            {/* title and date */}
                            <div className="w-full">
                              <div className="w-full flex flex-row items-center justify-between">
                                {/* title */}
                                <div className="flex flex-row items-center space-x-1">
                                  <p className="text-xs text-resumeTempFourTextPrimary font-medium tracking-tight">
                                    {mp.title}
                                  </p>
                                  <div
                                    className="text-1xs font-bold"
                                    style={{ color: tertiaryColor + "E6" }}>
                                    <span
                                      className="template-four-padding-skills rounded text-opacity-90"
                                      style={{
                                        backgroundColor: tertiaryColor + "1F", // opcity 12%
                                      }}>
                                      {mp?.category?.name}
                                    </span>
                                  </div>
                                </div>
                                {/* date */}
                                <div>
                                  <p className="text-1xs text-resumeTempFourTextPrimary leading-3.4 flex flex-row items-center space-x-1">
                                    <HiOutlineCalendarDays className="w-2 h-2 text-resumeTempFourIconColor" />
                                    <span className="mt-px">
                                    {formatDate(mp,profile?.dateFormat,t)} 
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* sub title and episodes */}
                            <div className="w-full mt-0.5 leading-none">
                              <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                  {mp?.positions && mp?.positions
                                    .filter(item =>
                                      !milestone_position.some(hide =>
                                        hide?.[mp?.id]?.includes(item.position_id)
                                      )
                                    )
                                    .map((p) => {
                                      const _pos = [p.position.name?.trim()];
                                      if (p.description)
                                        _pos.push((p.description).trim());
                                      return _pos.join(" - ");
                                    })
                                    .join(", ")
                                    .trim()}
                                </span>
                                {mp.platform && (
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">{` (${mp.platform})`}</span>
                                  )}
                                {mp.date_note && (
                                  <>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium px-1">
                                      &#8226;
                                    </span>
                                    <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                      {mp.date_note}
                                    </span>
                                  </>
                                )}
                            </div>
                            {/* description */}
                            <div className="w-full mt-2">
                              <div
                                className="text-7xs text-resumeTempFourTextPrimary tracking-resume leading-3.2 line-clamp-3"
                                dangerouslySetInnerHTML={{
                                  __html: mp?.description === 'null' || !mp?.description ? "" :  mp?.description,
                                }}
                              />
                            </div>
                          </div>
                          {/* image */}
                          {
                            show_image_milestone && 
                              <>
                              {
                                mp.thumbnail ? (
                                  <div className="h-23 w-23 bg-default rounded relative overflow-hidden">
                                    <img
                                      alt="milestones"
                                      src={mp.thumbnail.url}
                                      className="w-full h-full object-contain object-center"
                                    />
                                  </div>
                                ):
                                <div className="h-23 w-23 bg-default flex items-center justify-center rounded relative overflow-hidden">
                                    <img
                                      alt="milestones"
                                      src={CoverPlaceholderMilestone}
                                      className="w-1/2 object-contain object-center"
                                    />
                                  </div>
                              }
                              </>
                          }
                          
                        </div>
                      ))}
                    </div>}
                  </div>
                </div>
                {/* Divider */}
                {/* <div className="w-full py-4">
                  <ResumeLineDividerIconSVG full="true" />
                </div> */}
              </>
            )}
        </>
    );
}

export default MilestoneTG